import { StrictModeDroppable } from './Droppable'
export default StrictModeDroppable
